module.exports = __webpack_public_path__ + "static/img/cont57 (5).ecea174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont57 (5).jpg
// module id = jyGg
// module chunks = 0